export default [
  {
    path: '/vistoria/:vistoriaId/veiculo-ambiente-new',
    name: 'AmbienteCreateVeiculo',
    component: () => import('./VeiculoAmbienteForm'),
    meta: {
      routerBack: '/vistoria/:vistoriaId/ambiente-veiculo',
      domain: 'Ambiente',
      sidebar: false,
      title: 'Novo ambiente do veículo',
      icon: 'keyboard_backspace',
    },
  },
  {
    name: 'EditarAmbienteVeiculo',
    path: '/vistoria/:vistoriaId/ambiente-edit/:id',
    meta: {
      sidebar: false,
      routerBack: '/vistoria/:vistoriaId/ambiente',
      domain: 'Ambiente',
      title: 'Editar ambiente',
      icon: 'keyboard_backspace',
    },
  },
];



// WEBPACK FOOTER //
// ./src/app/Veiculos/Vistoria/Ambiente/AmbienteForm/VeiculoAmbienteFormRouter.js